import { render, staticRenderFns } from "./CampoUnico.vue?vue&type=template&id=4913c2de&"
import script from "./CampoUnico.vue?vue&type=script&lang=js&"
export * from "./CampoUnico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports